import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { NEVER, Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { JobService } from '../services/sections/job/job.service';

import { Comment } from 'src/app/models/comment.model';
import { FollowUpService } from '../services/sections/job/follow-up.service';

@Injectable({
	providedIn: 'root'
})
export class FollowUpResolver implements Resolve<Observable<Comment>> {

	constructor(
		private router: Router,
		private followUpService: FollowUpService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		GlobalSettingsService.isSecondaryLoaderLoading = true;

		return this.followUpService
			.getJobFollowUp(activatedRouteSnapshot.paramMap.get('token'))
			.pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				})
			);
	}
}
